import { setupGenerator } from '@yola/atomic-css-generator';
import { set } from '../helpers/generator';

const createCSSGenerator = async () => {
  const generator = await setupGenerator();
  set(generator);
};

export default createCSSGenerator;
